import { GitHubAccountType, type GitHubAppAuthorizationStatusUserDetails } from "@octopusdeploy/octopus-server-client";
import { GitHubAvatar } from "./GitHubInstallationLogo";
interface GitHubUserAvatarProps {
    user?: GitHubAppAuthorizationStatusUserDetails;
    small?: boolean;
}
export function GitHubUserAvatar({ user, small }: GitHubUserAvatarProps) {
    if (!user || !user.AvatarUrl) {
        return null;
    }
    const alt = user.Login ? `${user.Login} GitHub avatar` : "GitHub avatar";
    return <GitHubAvatar small={small} type={GitHubAccountType.User} avatarUrl={user.AvatarUrl} alt={alt}/>;
}
